// removed by extract-text-webpack-plugin
module.exports = {"root":"_2BaUGpIg77nc-BcIuk-QlO","muhimma":"_1k2h172weQtQY36a-R1joO"};


//////////////////
// WEBPACK FOOTER
// ./src/components/common/h1.scss
// module id = 1188
// module chunks = 0